"use strict";

const iconSharedUtils = {
  hasValidGradient: gradient => {
    return gradient && gradient.type && gradient.stops && gradient.stops.length > 0;
  }
};
const gradientUtils = {
  generateGradientId: gradient => {
    if (!gradient) return '';
    const type = gradient.type || '';
    const angle = gradient.angle || 0;
    const spec = gradient.specification || '';
    const stopsStr = gradient.stops ? gradient.stops.map(s => `${s.color}-${s.stop || s.hint || 0}`).join('_') : '';
    const gradientStr = `${type}-${angle}-${spec}-${stopsStr}`;
    let hash = 0;
    for (let i = 0; i < gradientStr.length; i++) {
      const char = gradientStr.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    const random = Math.floor(Math.random() * 10000);
    return `gradient-${type}-${Math.abs(hash).toString(16)}-${random}`;
  },
  addGradientToSvg: (svgContent, gradientDefs) => {
    if (!gradientDefs) return svgContent;
    const React = require('react');
    return React.cloneElement(svgContent, svgContent.props, gradientDefs, ...React.Children.toArray(svgContent.props.children));
  }
};
iconSharedUtils.getGradientUtils = () => {
  return gradientUtils;
};
module.exports = iconSharedUtils;